// @material-ui/core
import { Grid, Typography } from "@material-ui/core";
import React from "react";

export class ItemCardItem extends React.Component {
  render() {
    let md = this.props.full ? 12 : 6;
    return (
      <Grid item xs={12} md={md}>
        <Typography variant="body2">
          {this.props.value}
          <br />
          <small className="muted">{this.props.title}</small>
        </Typography>
      </Grid>
    );
  }
}



// WEBPACK FOOTER //
// ./src/library/card/item-card/item.js